module.exports = __webpack_public_path__ + "static/media/Portrait-10054.e5db60d9.jpg";